import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';

const ScrollToTop = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    const checkMobileMenuState = () => {
      // Check the nav element for nav-open class
      const navElement = document.querySelector('.nav');
      setIsMobileMenuOpen(navElement ? navElement.classList.contains('nav-open') : false);
    };

    window.addEventListener('scroll', handleScroll);

    // Observe changes to the nav element's class attribute
    const navElement = document.querySelector('.nav');
    if (navElement) {
      const observer = new MutationObserver(checkMobileMenuState);
      observer.observe(navElement, {
        attributes: true,
        attributeFilter: ['class']
      });
      
      // Initial check
      checkMobileMenuState();

      return () => {
        window.removeEventListener('scroll', handleScroll);
        observer.disconnect();
      };
    } else {
      // Fallback if nav element not found initially
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const scrollToTop = (event) => {
    if (event) {
      event.preventDefault();
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {showScrollTop && !isMobileMenuOpen && (
        <button 
          className="scroll-to-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 15l-6-6-6 6"/>
          </svg>
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
